import React from "react";
import "../programs/Programs.css";
import moment from "moment";
import { useRef } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const CompanyMembersList = (props) => {
  const userBusinessID =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).business_id
      : -1;
  const wrapperRef = useRef("");
  useOutsideDotClose(wrapperRef);
  function useOutsideDotClose(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          const data = [...props.membersData];
          for (let m of data) {
            m.modalOpened = false;
          }
          props.updateMemberData(data);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line
    }, [ref, props]);
  }

  return (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        {/* <div className="settings_input_hold"> */}
        <input
          type="text"
          ref={props.search}
          placeholder={"Search"}
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.search.current.value)}
        />
        {/* <div className="dash_box_search_icon sett_box_search_icon"></div> */}
        {/* </div> */}
        <div className="top_hold_buttons">
          <div className="programs_menu"></div>
        </div>
      </div>

      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">
          {props.membersData.length > 0 ? (
            <div className="programs_table">
              <div className="programs_cols">
                {userBusinessID <= 0 && (
                  <div className="programs_col_info">
                    <div className="programs_col_name">Company Name</div>
                    <div
                      className="programs_col_icon"
                      onClick={() =>
                        props.handleSorting("company", props.membersData)
                      }
                    ></div>
                  </div>
                )}
                <div className="programs_col_info">
                  <div className="programs_col_name">First Name</div>
                  <div
                    className="programs_col_icon"
                    onClick={() =>
                      props.handleSorting("firstName", props.membersData)
                    }
                  ></div>
                </div>
                <div className="programs_col_info">
                  <div className="programs_col_name">Last Name</div>
                  <div
                    className="programs_col_icon"
                    onClick={() =>
                      props.handleSorting("lastName", props.membersData)
                    }
                  ></div>
                </div>
                <div className="programs_col_info">
                  <div className="programs_col_name">Date Of Birth</div>
                  <div
                    className="programs_col_icon"
                    onClick={() =>
                      props.handleSorting("birthday", props.membersData)
                    }
                  ></div>
                </div>
                {userBusinessID > 0 && (
                  <>
                    <div className="programs_col_info">
                      <div className="programs_col_name">Problem Area</div>
                      <div
                        className="programs_col_icon"
                        onClick={() =>
                          props.handleSorting("problemArea", props.membersData)
                        }
                      ></div>
                    </div>
                    <div className="programs_col_info">
                      <div className="programs_col_name">Sub Problem</div>
                      <div
                        className="programs_col_icon"
                        onClick={() =>
                          props.handleSorting("subProblem", props.membersData)
                        }
                      ></div>
                    </div>
                    <div className="programs_col_info">
                      <div className="programs_col_name">Therapist</div>
                      <div
                        className="programs_col_icon"
                        onClick={() =>
                          props.handleSorting(
                            "mainTherapist",
                            props.membersData
                          )
                        }
                      ></div>
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : !props.loading ? (
            <div className="programs_table_no_content">
              <div className="no_content_notice_contain">
                {props.contentLoaded ? (
                  <>
                    <div className="programs_no_results_img"></div>
                    <div className="programs_no_res_main">
                      You have no Company Members
                    </div>
                  </>
                ) : (
                  <div className="p_load"></div>
                )}
              </div>
            </div>
          ) : (
            <div className="programs_table_no_content">
              <div className="no_content_notice_contain">
              <div className="p_load"></div>
            </div>
            </div>
          )}
          {props.membersData.length > 0 && (
            <div className="tbl_content_hold tbl_content_settings">
              {props.membersData &&
                props.membersData.map((item, i) => (
                  <div
                    key={i}
                    className="programs_tbl_content"
                  >
                    <div className="programs_tbl_row client-list_row">
                      {userBusinessID <= 0 && (
                        <div className="programs_tbl_col_contain">
                          <div className="programs_tbl_col">{item.company}</div>
                        </div>
                      )}
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">{item.firstName}</div>
                      </div>
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">{item.lastName}</div>
                      </div>
                      <div className="programs_tbl_col_contain">
                        <div className="programs_tbl_col">
                          {moment(item.birthday).format("L")}
                        </div>
                      </div>
                      {userBusinessID > 0 && (
                        <>
                          <div className="programs_tbl_col_contain">
                            <div className="programs_tbl_col">
                              {item.problemArea}
                            </div>
                          </div>
                          <div className="programs_tbl_col_contain">
                            <div className="programs_tbl_col">
                              {item.subProblem}
                            </div>
                          </div>
                          <div className="programs_tbl_col_contain">
                            <div className="programs_tbl_col">
                              {item.mainTherapist}
                            </div>
                          </div>
                        </>
                      )}
                      {!item.modalOpened ? (
                        <div
                          className="programs_tbl_col programs_tbl_col_last list-options"
                          style={{ height: 0 }}
                          onClick={() => props.modalOpened(i)}
                        >
                          ...
                        </div>
                      ) : (
                        <div
                          className="programs_tbl_col programs_tbl_col_last list-options"
                          style={{ height: 0, pointerEvents: "none" }}
                          onClick={() => props.modalOpened(i)}
                        >
                          ...
                        </div>
                      )}
                      {item.modalOpened && (
                        <div
                          className={
                            i === props.membersData.length - 1
                              ? "workouts-list__container_last hexercise-list__container"
                              : "client-list__container hexercise-list__container"
                          }
                          ref={wrapperRef}
                        >
                          <Link
                            to={"/edit-member/" + item.memberId}
                            style={{ display: "block", textDecoration: "none" }}
                            className="client-list-option"
                          >
                            <div>Edit Member</div>
                          </Link>
                          <div
                            className="client-list-option client-list-option__delete"
                            onClick={() =>
                              props.handleDeleteModal(item.memberId)
                            }
                          >
                            Delete Member
                          </div>
                          {item.patient_code != null &&
                            item.is_registered !== 1 && (
                              <>
                                <div
                                  className="client-list-option client-list-option__delete"
                                  onClick={() =>
                                    props.copyToClipboard(i, item.patient_code)
                                  }
                                >
                                  Copy Invite Link
                                </div>
                                <div
                                  className="client-list-option client-list-option__delete"
                                  onClick={() =>
                                    props.memberResendInvitation(item)
                                  }
                                >
                                  Resend Invite
                                </div>
                              </>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              {props.modalVisible && (
                <div className="dlt_wrapper">
                  <div className="dbl_place_on_page">
                    <div className="dlt_surround ">
                      <div className="dlt_title">Delete Member</div>
                      <div className="dlt_description">
                        <p>Do you want to delete Member?</p>
                      </div>
                      <div className="dlt_exit_btm">
                        <div
                          className="dlt_exit_btn dlt_eb_first"
                          onClick={props.closeDeleteModal}
                        >
                          Cancel
                        </div>
                        <div
                          className="dlt_exit_btn dlt_eb_scnd"
                          onClick={() => props.handleDeleteMember()}
                        >
                          Delete
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyMembersList;
